var exports = {
  "t": "newOptionName__fWHbko",
};

module.exports = exports;
